import React, { FunctionComponent } from 'react';
import { SignInPageLayout } from '../layout/SignInPageLayout';
import { PurchaseDivTest } from '../component/purchase-test/PurchaseDivTest';

interface Props {
  onChange: (e: any) => void;
}

export const PurchasePageTest: FunctionComponent<Props> = ({ onChange }) => (
  <SignInPageLayout centerDesktop={<PurchaseDivTest onChange={onChange} />} />
);
